import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    setIsLoggedIn(!!token);
    setLoading(false);
  }, []);

  const login = () => {
    sessionStorage.setItem("token", "logged-in");
    setIsLoggedIn(true);
  };

  const logout = () => {
    sessionStorage.clear();
    setIsLoggedIn(false);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
